import React, { useState } from "react";
import "../App.css";
import { useInView } from "../hooks/useInView";
import { useNavigate } from "react-router-dom";
import { useCareModal } from "../context/CareModalContext";
import {
  FaLinkedin,
  FaFacebookF,
  FaTiktok,
  FaWhatsapp,
  FaInstagram,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Contact = () => {
  const navigate = useNavigate();
  const { openBookCare, openJoinTeam } = useCareModal();
  const [formRef, formInView] = useInView();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "contact",
          payload: form,
        }),
      });

      if (!response.ok) {
        console.error("Failed to send contact message");
        alert(
          "Sorry, something went wrong sending your message. Please try again."
        );
        return;
      }

      alert("Thank you – your message has been sent.");
      setForm({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    } catch (err) {
      console.error("Error sending contact message:", err);
      alert(
        "Sorry, something went wrong sending your message. Please try again."
      );
    }
  };

  return (
    <>
      {/* HERO */}
      <section className="hero contact-hero">
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1 className="hero-title">Contact</h1>
          <p className="hero-subtitle">
            We&apos;re here to listen, support, and respond with care.
          </p>

          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={openBookCare}>
              Book For Care
            </button>
            <button className="btn btn-light" onClick={openJoinTeam}>
              Join Our Team
            </button>
          </div>
        </div>
      </section>

      {/* CONTACT SPLIT SECTION */}
      <section className="section contact-section">
        <div className="contact-grid">
          {/* LEFT – INFO */}
          <div className="contact-info">
            <h3>Get In Touch</h3>

            {/* Phone – clickable, opens dialer */}
            <div className="contact-info-item">
              <a
                href="tel:+447508667276"
                className="contact-info-link"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.6rem",
                  textDecoration: "none",
                  color: "inherit",
                  width: "100%",
                }}
              >
                <span className="contact-info-icon">
                  <FaPhoneAlt />
                </span>
                <span>+44 7508 667276</span>
              </a>
            </div>

            {/* Email – clickable, opens mail app */}
            <div className="contact-info-item">
              <a
                href="mailto:ndilsdailycare@gmail.com"
                className="contact-info-link"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.6rem",
                  textDecoration: "none",
                  color: "inherit",
                  width: "100%",
                }}
              >
                <span className="contact-info-icon">
                  <FaEnvelope />
                </span>
                <span>ndilsdailycare@gmail.com</span>
              </a>
            </div>

            {/* Address */}
            <div className="contact-info-item">
              <a
                href="https://www.google.com/maps/search/?api=1&query=NP18+1LS"
                target="_blank"
                rel="noreferrer"
                className="contact-info-link"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.6rem",
                  textDecoration: "none",
                  color: "inherit",
                  width: "100%",
                }}
              >
                <span className="contact-info-icon">
                  <FaMapMarkerAlt />
                </span>
                <span>NP18 1LS</span>
              </a>
            </div>

            {/* SOCIAL ICONS */}
            {/* (unchanged) */}
            {/* ... existing social links here ... */}
          </div>

          {/* RIGHT – FORM */}
          <div className="contact-form-wrapper">
            <h3>Contact Form</h3>

            <form
              ref={formRef}
              className={`contact-form ${formInView ? "in-view" : ""}`}
              onSubmit={handleSubmit}
            >
              <div className="contact-form-row">
                <input
                  type="text"
                  name="name"
                  placeholder="name"
                  className="contact-input-pill"
                  style={{ "--delay": "0s" }}
                  required
                  value={form.name}
                  onChange={handleChange}
                />
                <input
                  type="email"
                  name="email"
                  placeholder="email"
                  className="contact-input-pill"
                  style={{ "--delay": "0.1s" }}
                  required
                  value={form.email}
                  onChange={handleChange}
                />
              </div>

              <input
                type="text"
                name="phone"
                placeholder="phone"
                className="contact-input-pill contact-input-full"
                style={{ "--delay": "0.15s" }}
                value={form.phone}
                onChange={handleChange}
              />

              <input
                type="text"
                name="subject"
                placeholder="subject"
                className="contact-input-pill contact-input-full"
                style={{ "--delay": "0.2s" }}
                required
                value={form.subject}
                onChange={handleChange}
              />

              <textarea
                name="message"
                placeholder="message"
                className="contact-input-pill contact-input-full contact-message"
                rows={4}
                style={{ "--delay": "0.3s" }}
                required
                value={form.message}
                onChange={handleChange}
              />

              <button
                type="submit"
                className="btn contact-send-btn"
                style={{ "--delay": "0.4s" }}
              >
                send
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* MAP section unchanged */}
    </>
  );
};

export default Contact;
